/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BadgeTypeEnum {
    ADMIN = 'ADMIN',
    CONTENT_CREATOR = 'CONTENT_CREATOR',
    TOTW = 'TOTW',
    MOST_GOALS = 'MOST_GOALS',
    PLAYER = 'PLAYER',
    PLAYER_RETIRED = 'PLAYER_RETIRED',
    INSIDER_LVL_1 = 'INSIDER_LVL_1',
    INSIDER_LVL_2 = 'INSIDER_LVL_2',
    INSIDER_LVL_3 = 'INSIDER_LVL_3',
    INSIDER_LVL_4 = 'INSIDER_LVL_4',
    PREMIUM = 'PREMIUM',
    MAN_OF_THE_MATCH = 'MAN_OF_THE_MATCH',
}
